import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

interface WorkflowRegel {
  regel_id: number;
  name: string;
  trigger_typ: string;
  aktiv: boolean;
}

interface Props {
  authToken: string;
}

const WorkflowSection: React.FC<Props> = ({ authToken }) => {
  const [regeln, setRegeln] = useState<WorkflowRegel[]>([]);
  const [loading, setLoading] = useState(true);
  const headers = useMemo(() => ({ Authorization: `Bearer ${authToken}` }), [authToken]);

  useEffect(() => {
    axios.get<WorkflowRegel[]>(`${API_URL}/api/workflow-regeln`, { headers })
      .then(r => setRegeln(Array.isArray(r.data) ? r.data : []))
      .finally(() => setLoading(false));
  }, [headers]);

  const toggleAktiv = async (id: number, aktiv: boolean) => {
    await axios.patch(`${API_URL}/api/workflow-regeln/${id}`, { aktiv }, { headers });
    setRegeln(prev => prev.map(r => r.regel_id === id ? { ...r, aktiv } : r));
  };

  const deleteRegel = async (id: number) => {
    if (!window.confirm('Workflow-Regel löschen?')) return;
    await axios.delete(`${API_URL}/api/workflow-regeln/${id}`, { headers });
    setRegeln(prev => prev.filter(r => r.regel_id !== id));
  };

  if (loading) return <div>Lade Workflow-Regeln…</div>;

  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Workflows</h3>
      {regeln.length === 0 ? (
        <p style={{ color: 'var(--ink-2)' }}>Noch keine Workflow-Regeln definiert.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {regeln.map(r => (
            <div key={r.regel_id} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '10px 14px', border: '1px solid var(--bone-3)', borderRadius: 0,
              background: r.aktiv ? 'var(--bone)' : 'var(--bone)', opacity: r.aktiv ? 1 : 0.65,
            }}>
              <div>
                <div style={{ fontWeight: 500, fontSize: 14 }}>{r.name}</div>
                <div style={{ fontSize: 12, color: 'var(--ink-2)' }}>Trigger: {r.trigger_typ}</div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  onClick={() => toggleAktiv(r.regel_id, !r.aktiv)}
                  style={{ fontSize: 12, padding: '4px 10px', cursor: 'pointer',
                    border: '1px solid var(--bone-3)', borderRadius: 0, background: 'var(--bone)' }}
                >
                  {r.aktiv ? 'Deaktivieren' : 'Aktivieren'}
                </button>
                <button
                  onClick={() => deleteRegel(r.regel_id)}
                  style={{ fontSize: 12, padding: '4px 10px', cursor: 'pointer',
                    border: '1px solid var(--red)', borderRadius: 0,
                    background: 'var(--bone)', color: 'var(--red)' }}
                >
                  Löschen
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WorkflowSection;
